import React, { useState } from 'react';
import { formations, experiences } from '../../data/cursus';
import { useReveal } from '../../hooks/useReveal';
import '../../styles/parcours.css';

const TABS = [
  { id: 'xp', label: 'Expériences', items: experiences },
  { id: 'formation', label: 'Formations', items: formations }
];

const Parcours = () => {
  const [tab, setTab] = useState('xp');
  const active = TABS.find((t) => t.id === tab);

  // Les éléments de l'onglet sont montés après le premier passage de l'observateur :
  // sans ce re-scan, ils resteraient masqués à vie.
  useReveal([tab]);

  return (
    <section className="section parcours" id="parcours">
      <div className="shell">
        <div className="parcours-top" data-reveal>
          <div className="section-head parcours-head">
            <p className="eyebrow">Parcours</p>
            <h2>
              Six ans <em>entre code et design</em>
            </h2>
          </div>

          <div className="parcours-tabs" role="tablist" aria-label="Filtrer le parcours">
            {TABS.map((t) => (
              <button
                key={t.id}
                role="tab"
                type="button"
                id={`tab-${t.id}`}
                aria-selected={tab === t.id}
                aria-controls={`panel-${t.id}`}
                className={`parcours-tab ${tab === t.id ? 'is-active' : ''}`}
                onClick={() => setTab(t.id)}
              >
                {t.label}
                <span className="parcours-tab-count">{t.items.length}</span>
              </button>
            ))}
          </div>
        </div>

        <ol
          className="timeline"
          id={`panel-${active.id}`}
          role="tabpanel"
          aria-labelledby={`tab-${active.id}`}
        >
          {active.items.map((item, i) => (
            <li
              className="timeline-item"
              key={item.id}
              style={{ '--reveal-delay': `${i * 50}ms` }}
              data-reveal
            >
              <span className="timeline-years">{item.years}</span>

              <span className="timeline-node" aria-hidden="true" />

              <div className="timeline-card">
                <div className="timeline-card-top">
                  <span className="timeline-label">{item.label}</span>
                  {item.duration && (
                    <span className="timeline-duration">{item.duration}</span>
                  )}
                </div>
                <h3 className="timeline-title">{item.title}</h3>
                <p className="timeline-place">{item.place}</p>
                <p className="timeline-desc">{item.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Parcours;
